import { http } from "./client";
import type {
  BoxInvite,
  Health,
  HistoryItem,
  Me,
  NewFolder,
  RecipientList,
  RecipientListInput,
  ReportPreview,
  ReportPreviewRequest,
  ReportSendRequest,
  ReportSendResult,
  WatchedFolder,
} from "./types";

const V1 = "/api/v1";

export const api = {
  me: () => http.get<Me>(`${V1}/me`).then((r) => r.data),
  health: () => http.get<Health>(`${V1}/health`).then((r) => r.data),

  previewReport: (body: ReportPreviewRequest) =>
    http.post<ReportPreview>(`${V1}/reports/preview`, body).then((r) => r.data),
  sendReport: (body: ReportSendRequest) =>
    http.post<ReportSendResult>(`${V1}/reports/send`, body).then((r) => r.data),

  listRecipients: () =>
    http
      .get<{ lists: RecipientList[] }>(`${V1}/recipients`)
      .then((r) => r.data.lists),
  createRecipient: (body: RecipientListInput) =>
    http.post<RecipientList>(`${V1}/recipients`, body).then((r) => r.data),
  updateRecipient: (id: string, body: RecipientListInput) =>
    http.put<RecipientList>(`${V1}/recipients/${id}`, body).then((r) => r.data),
  deleteRecipient: (id: string) =>
    http.delete(`${V1}/recipients/${id}`).then(() => undefined),

  listFolders: () =>
    http
      .get<{ folders: WatchedFolder[] }>(`${V1}/folders`)
      .then((r) => r.data.folders),
  addFolder: (body: NewFolder) =>
    http.post<WatchedFolder>(`${V1}/folders`, body).then((r) => r.data),
  setFolderEnabled: (id: string, enabled: boolean) =>
    http
      .patch<WatchedFolder>(`${V1}/folders/${id}`, { enabled })
      .then((r) => r.data),
  deleteFolder: (id: string) =>
    http.delete(`${V1}/folders/${id}`).then(() => undefined),
  crawlFolder: (id: string) =>
    http
      .post<{ queued: true }>(`${V1}/folders/${id}/crawl`)
      .then((r) => r.data),

  listBoxInvites: () =>
    http
      .get<{ invites: BoxInvite[] }>(`${V1}/box/invites`)
      .then((r) => r.data.invites),
  acceptBoxInvite: (id: string) =>
    http
      .post<{ accepted: BoxInvite }>(`${V1}/box/invites/${id}/accept`)
      .then((r) => r.data.accepted),

  listHistory: () =>
    http
      .get<{ items: HistoryItem[] }>(`${V1}/history`)
      .then((r) => r.data.items),
  historyHtml: (id: string) =>
    http
      .get<string>(`${V1}/history/${id}/html`, { responseType: "text" })
      .then((r) => r.data),
};
